export default (theme) => ({
  appointments: {
    position: 'relative',
  },
  tabsContainer: {
    justifyContent: 'flex-end',
    paddingRight: 100,
    [theme.breakpoints.down('md')]: {
      paddingRight: 0,
      justifyContent: 'center',
    },
  },
  tabsHeader: {
    width: '100%',
    height: 'auto',
  },
  wrapper: {
    borderBottom: `1px solid ${theme.palette.disabled.main}`,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    height: 105,
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      paddingTop: 16,
      height: 'unset',
      alignItems: 'center',
    },
  },
  search: {
    padding: '10px 25px 0',
  },
  tab: {
    [theme.breakpoints.down('md')]: {
      width: '50%',
    },
  },
  bookAppointmentButton: {
    marginLeft: 100,
    height: 40,
    minHeight: 40,
    marginBottom: 30,
    [theme.breakpoints.down('md')]: {
      marginLeft: 0,
      height: 30,
      minWidth: 30,
      minHeight: 30,
      padding: 0,
      width: 30,
      marginBottom: 0,
    },
  },
  calendarIcon: {
    fill: theme.palette.background.white,
  },
  bookAppointmentButtonText: {
    marginLeft: 10,
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  tabsWrapper: {
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
});
